const PACIFIC_TIME_ZONE = 'America/Los_Angeles';

const datePartsInPacific = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: PACIFIC_TIME_ZONE,
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date).map((part) => [part.type, part.value]));
};

export const formatInboundDateTime = (value, fallback = 'Not recorded') => {
  const parts = datePartsInPacific(value);
  if (!parts) return fallback;
  return `${parts.month}/${parts.day}/${parts.year} ${parts.hour}:${parts.minute} ${parts.dayPeriod}`;
};

const quantity = (value) => Number(value || 0).toLocaleString('en-US');

export const cleanupItemSummary = (item = {}) => {
  const evidence = item.evidence || {};
  const planned = Number(evidence.planned || 0);
  const shipped = Number(evidence.shipped || 0);
  const eadinReceived = Number(evidence.eadin_received || 0);
  const shipHeroReceived = Number(evidence.shiphero_received || 0);
  const received = eadinReceived === shipHeroReceived
    ? `${quantity(eadinReceived)} received in Eadin and ShipHero`
    : `${quantity(eadinReceived)} received in Eadin and ${quantity(shipHeroReceived)} in ShipHero`;

  switch (item.kind) {
    case 'manual_move_no_transfer':
      return `${quantity(item.units)} units left Receiving through a quantity edit with no transfer record. Eadin can't tell where they went.`;
    case 'unverified_destination':
      return `${quantity(item.units)} units were transferred to an unmapped or inactive location, so Eadin can't verify where they went.`;
    case 'unconfirmed_shipped_qty':
      return `Shipped quantity was never confirmed: ${quantity(planned)} expected, ${received}.`;
    case 'supplier_short_ship':
      if (eadinReceived === shipped && shipHeroReceived === shipped) {
        return `Supplier shipped ${quantity(shipped)} of ${quantity(planned)} planned; all ${quantity(shipped)} received.`;
      }
      return `Supplier shipped ${quantity(shipped)} of ${quantity(planned)} planned; ${received}.`;
    case 'missing_delivery_scan':
      return "Received, but UPS has no delivery scan, so the receiving and put-away clocks can't start.";
    case 'receipt_source_mismatch':
      return `Received quantity differs: ${quantity(eadinReceived)} in Eadin and ${quantity(shipHeroReceived)} in ShipHero.`;
    default:
      return `${quantity(item.units)} units need a data check.`;
  }
};

const resolutionReasons = {
  verified_location_quantity: 'Verified location quantity',
  source_record_corrected: 'Source record corrected',
  supplier_short_confirmed: 'Supplier short confirmed',
  auto_reconciled: 'Automatically reconciled',
};

const eventActions = {
  detected: 'Detected',
  resolved: 'Resolved',
  auto_resolved: 'Automatically resolved',
  reopened: 'Reopened',
  auto_reopened: 'Automatically reopened',
  evidence_changed: 'Source evidence changed',
};

const movementTypes = {
  receive: 'Received',
  transfer: 'Transfer',
  adjustment: 'Quantity adjustment',
};

export const resolutionReasonLabel = (reason) => resolutionReasons[reason] || 'Other resolution';
export const cleanupEventLabel = (action) => eventActions[action] || 'Updated';
export const movementTypeLabel = (type) => movementTypes[type] || 'Other movement';
